import CreateEditEntityTemplateModal from '@/ui/components/createEditEntityTemplateModal/CreateEditEntityTemplateModal';
import IconButton from '@payaca/components/button/IconButton';
import { PublicEntityTemplate } from '@payaca/types/entity-templates';
import { FC, useState, type JSX } from 'react';
import EntityTemplateCard from '../entityTemplateCard/EntityTemplateCard';
import './ScheduledEventLinkedTaskTemplatesPanel.sass';

type Props = {
  taskTemplates: Omit<PublicEntityTemplate<'task'>, 'publicId'>[];
  onChange: (
    taskTemplates: Omit<PublicEntityTemplate<'task'>, 'publicId'>[]
  ) => Promise<void>;
};
const ScheduledEventLinkedTaskTemplatesPanel: FC<Props> = ({
  taskTemplates,
  onChange,
}: Props): JSX.Element | null => {
  const [showCreateTaskTemplateModal, setShowCreateTaskTemplateModal] =
    useState(false);

  return (
    <div className={'scheduled-event-linked-task-templates-panel'}>
      <IconButton
        size="xs"
        icon="plus.3"
        onClick={() => setShowCreateTaskTemplateModal(true)}
      />
      {taskTemplates.map((t, i) => {
        return (
          <EntityTemplateCard
            editInModal={false}
            showEntityTypeIcon={true}
            key={i}
            template={t}
            isChildOfScheduledEvent
            allowedQuickActions={['delete']}
            onChange={(updatedTaskTemplate) =>
              new Promise<void>((resolve, reject) => {
                const updatedTaskTemplates = [...taskTemplates];
                updatedTaskTemplates[i] = updatedTaskTemplate as Omit<
                  PublicEntityTemplate<'task'>,
                  'publicId'
                >;
                onChange(updatedTaskTemplates).then(resolve).catch(reject);
              })
            }
            onRemove={() =>
              new Promise<void>((resolve, reject) => {
                onChange(taskTemplates.filter((_, j) => j !== i))
                  .then(resolve)
                  .catch(reject);
              })
            }
            onClick={(showEditTemplateModal) => showEditTemplateModal()}
          />
        );
      })}

      <CreateEditEntityTemplateModal
        isOpen={showCreateTaskTemplateModal}
        onClose={() => setShowCreateTaskTemplateModal(false)}
        action="Create"
        isChildOfScheduledEvent
        template={{
          entityType: 'task',
          data: {},
        }}
        onRequestSave={(newEntityTemplate) => {
          void onChange([
            ...taskTemplates,
            newEntityTemplate as Omit<PublicEntityTemplate<'task'>, 'publicId'>,
          ]).then(() => setShowCreateTaskTemplateModal(false));
        }}
      />
    </div>
  );
};
export default ScheduledEventLinkedTaskTemplatesPanel;
